import React from 'react'
import Hero from '../Sections/Hero';
import LittlePro from '../Sections/LittlePro';
import Practice from '../Sections/Practice';
import ClickBelow from '../Sections/ClickBelow';
import AboutMe from '../Sections/AboutMe';

const Home = () => {
  return (
    <>
    <Hero></Hero>
    <LittlePro></LittlePro>
    <Practice></Practice>
    <ClickBelow></ClickBelow>
    <AboutMe></AboutMe>
    </>
  )
}

export default Home
